import { supabase } from "./supabase";

// Registra o aceite dos termos pela serverless (api/registrar-aceite), que é
// quem captura IP e user-agent reais. Daqui vai só o id da ficha + quem aceitou.
//
// Nunca bloqueia o fluxo: se falhar, a ficha já está salva e o aceite pode ser
// re-registrado depois. Devolve { ok, aceites } ou { ok:false } em silêncio.
export async function registrarAceite(fichaId, { editToken, aceitante, origem } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (!editToken) {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  }
  try {
    const res = await fetch("/api/registrar-aceite", {
      method: "POST",
      headers,
      body: JSON.stringify({ ficha_id: fichaId, edit_token: editToken || undefined, aceitante: aceitante || undefined, origem }),
    });
    const json = await res.json().catch(() => ({}));
    return res.ok ? json : { ok: false, erro: json.error || "Falha ao registrar o aceite." };
  } catch {
    return { ok: false, erro: "Falha ao registrar o aceite." };
  }
}
